import { useQuery } from "@tanstack/react-query";

import { useApiClient } from "../useApiClient";

import {
  ANALYTICS_QUERY_KEY,
  toAnalyticsQuery,
  type AnalyticsFilters,
} from "./useSummary";

export function useWinRateCharts(
  filters: AnalyticsFilters = {},
  options: { enabled?: boolean } = {},
) {
  const client = useApiClient();
  return useQuery({
    queryKey: [...ANALYTICS_QUERY_KEY, "win-rate-charts", filters],
    enabled: options.enabled ?? true,
    queryFn: async () => {
      const { data, error } = await client.GET("/api/analytics/win-rate-charts", {
        params: {
          query: toAnalyticsQuery(filters),
        },
      });
      if (error !== undefined) {
        throw new Error("Failed to load win-rate charts");
      }
      return data;
    },
  });
}
